import React from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { makeStyles, Dialog, DialogTitle, Icon, Button, Typography, DialogActions, DialogContent } from '@material-ui/core';
import { useHistory } from "react-router";

export const useStyles = makeStyles((theme) => ({
  restrictorDialog: {
    maxWidth: 700,
    margin: "auto",
  },
  content: { },
  backButton: {
    padding: 8,
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  closeIcon: {
    position: 'absolute',
    right: 16,
    top: 16,
    [theme.breakpoints.down('xs')]: {
        right: 16,
    },
    '&:hover': {
        cursor: 'pointer',
    },
  },
}));

const ConfigurationRestrictor = (props) => {
  const { externalAccess, status, onClose } = props;
  const classes = useStyles();
  const history = useHistory();
  return (
    <Dialog className={classes.restrictorDialog} open={true} >
       <DialogTitle>
          <Typography variant="body1">
            <b>
              {t('restrictor.title')}
            </b>
          </Typography>
          {status === "reorderable" && !externalAccess && <Icon className={classes.closeIcon} onClick={onClose}>
              close
          </Icon>}
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.content} variant="body2">
          {status === "reorderable" ? externalAccess ? t('restrictor.externalReorderableContent') : t('restrictor.listReorderableContent') : 
            status === "inactive" ?  t('restrictor.inactiveContent') : ""}
        </Typography>
      </DialogContent>
      <DialogActions>
        {((status === "reorderable" && externalAccess) || status === "inactive") && (
          <Button className={classes.backButton} color="primary" onClick={() => history.push("/products/overview")}>
              {t('restrictor.backToOverview')}
          </Button>
        )}
      </DialogActions>
  </Dialog>
  );
}

export default ConfigurationRestrictor;
